import type { Entity } from "../gen/livesoup/v1/realtime_pb";
import type { PlotInfo } from "../net/api";

type Role = "owner" | "builder" | "";

export function canPlaceIn(plot: PlotInfo, role: Role): boolean {
  return plot.placement_policy === "public" || role !== "";
}

/** Drafts change only through the layout API, so in-world removal is for live entities. */
export function isRemovable(e: Entity, myId: string | undefined, role: Role): boolean {
  if (!myId || e.stage !== "live") return false;
  return e.placedById === myId || role !== "";
}

export function entityLabel(e: Entity): string {
  return e.name || e.assetCode || e.role || "幾何體";
}

const ROLE_RE = /^[a-z][a-z0-9_:-]{0,31}$/;

export function validateRole(role: string): string | null {
  return role === "" || ROLE_RE.test(role) ? null : "role 必須以小寫英文字母開頭，只含小寫英數、底線、冒號或連字號，最多 32 字元";
}

export function parseTags(text: string): { tags: string[]; error: string | null } {
  const tags = text.split(",").map((t) => t.trim()).filter((t) => t !== "");
  if (tags.length > 16) return { tags, error: "最多 16 個標籤" };
  if (tags.some((t) => [...t].length > 32)) return { tags, error: "每個標籤最多 32 字元" };
  return { tags, error: null };
}
